<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { computed } from "vue";
import ConnectionsPane from "./ConnectionsPane.vue";
import EmailPane from "./EmailPane.vue";
import EmbedPane from "./EmbedPane.vue";
import IntegrateNav from "./IntegrateNav.vue";
import SharePane from "./SharePane.vue";

const store = useAppStore();
const activePane = computed(() => {
  if (store.integratePane === "embed") return EmbedPane;
  if (store.integratePane === "share") return SharePane;
  if (store.integratePane === "email" && store.formId) return EmailPane;
  return ConnectionsPane;
});
</script>

<template>
  <main class="integrate-view">
    <IntegrateNav />
    <KeepAlive>
      <component :is="activePane" />
    </KeepAlive>
  </main>
</template>

<style scoped>
.integrate-view {
  --integrate-side-panel-min-width: 360px;
  --integrate-side-panel-max-width: 480px;
  --integrate-side-panel-width: clamp(
    var(--integrate-side-panel-min-width),
    24vw,
    var(--integrate-side-panel-max-width)
  );
  display: grid;
  grid-template-columns: 208px minmax(0, 1fr);
  min-height: 0;
  height: calc(100vh - 100px);
  box-sizing: border-box;
  overflow: hidden;
  padding: 12px 16px 16px;
  gap: 12px;
  background: var(--gray-100, #f2f4f7);
}
@media (max-width: 768px) {
  .integrate-view {
    grid-template-columns: 72px minmax(0, 1fr);
    padding-inline: 8px;
  }
  :deep(.integrate-nav__label) {
    display: none;
  }
}
</style>

<style>
.integrate-preview-card {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border-radius: 12px;
  background: var(--base-white, #fff);
  box-sizing: border-box;
}
.integrate-close-button {
  --n-color: transparent !important;
  --n-color-hover: var(--gray-100, #f2f4f7) !important;
  --n-color-pressed: var(--gray-100, #f2f4f7) !important;
  --n-box-shadow: none !important;
  --n-text-color: var(--integrate-close-color, var(--gray-500, #667085)) !important;
  --n-text-color-hover: var(--gray-700, #344054) !important;
  --n-text-color-pressed: var(--gray-700, #344054) !important;
  width: 32px;
  min-width: 32px;
  height: 32px;
  padding: 6px !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: var(--integrate-close-color, var(--gray-500, #667085)) !important;
}
.integrate-close-button svg {
  width: 20px;
  height: 20px;
  color: var(--integrate-close-color, var(--gray-500, #667085)) !important;
}
.integrate-close-button .n-button__border,
.integrate-close-button .n-button__state-border {
  display: none !important;
}
.integrate-preview-chip.n-tag,
.integrate-preview-chip .n-tag {
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--primary-50, #eff4ff);
  color: var(--primary-700, #004eeb);
  font-size: 12px;
  font-weight: 600;
}
</style>
